import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { I18nModule } from '@spartacus/core';
import { CardModule, FormErrorsModule, IconModule, SpinnerModule } from '@spartacus/storefront';
import { CustomIconsModule } from '../../../../../../../custom/icons/custom-icons.module';
import { CustomPaymentFormComponent } from './custom-payment-form.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgSelectModule,
    CardModule,
    I18nModule,
    IconModule,
    SpinnerModule,
    FormErrorsModule,
    CustomIconsModule,
  ],
  declarations: [CustomPaymentFormComponent],
  exports: [CustomPaymentFormComponent]
})
export class CustomPaymentFormModule { }
